(() => {
  'use strict';

  const intents = {
    asesoramiento: ['Asesoramiento de producto', 'Quisiera asesoramiento para elegir los materiales de mi proyecto.'],
    presupuesto: ['Presupuesto', 'Quisiera solicitar un presupuesto para mi proyecto.'],
    showroom: ['Visita a showroom', 'Quisiera coordinar una visita al showroom para conocer los materiales.'],
    muestras: ['Muestras', 'Quisiera consultar por muestras para comparar los materiales en mi espacio.'],
    'wall-panels-muestra': ['Muestras', 'Quisiera consultar por una muestra de wall panel para mi proyecto.'],
    'wall-panels': ['Asesoramiento de producto', 'Quisiera asesoramiento para incorporar wall panels en mi espacio.'],
    'icons-riccetto': ['Asesoramiento de producto', 'Me interesa la colección ICONS de María Noel Riccetto y quisiera conocer sus opciones.'],
    'puertas-europeas': ['Asesoramiento de producto', 'Quisiera asesoramiento para elegir puertas y definir medidas y terminaciones.'],
    interiores: ['Obra o proyecto', 'Quisiera conversar sobre los materiales y las terminaciones de mi proyecto.'],
    'vinilico-homogeneo': ['Obra o proyecto', 'Quisiera asesoramiento para definir un sistema vinílico homogéneo para mi proyecto.'],
    instalacion: ['Instalación', 'Quisiera coordinar una evaluación para la instalación de mi piso.'],
    restauracion: ['Instalación', 'Quisiera evaluar la restauración y protección de mi piso de madera.'],
    nivelacion: ['Instalación', 'Quisiera evaluar la base y la nivelación necesaria antes de instalar el piso.'],
    servicios: ['Instalación', 'Quisiera conocer los servicios de preparación, instalación y restauración para mi proyecto.'],
    mantenimiento: ['Asesoramiento de producto', 'Quisiera asesoramiento sobre el cuidado y mantenimiento de mi piso.'],
    zocalos: ['Asesoramiento de producto', 'Quisiera elegir los zócalos y las terminaciones para mi piso.'],
    deportes: ['Obra o proyecto', 'Quisiera asesoramiento para un piso deportivo.'],
    postventa: ['Postventa', 'Necesito atención sobre una compra realizada.']
  };
  const knownProducts = {
    iconsxmnr: 'ICONS · María Noel Riccetto',
    'roble-natural-125-x-1200mm': 'Roble Natural',
    'roble-eslavonia-extra-grande-240': 'Roble Eslavonia Extra Grande 240',
    'wall-panel-revestimiento-alistonado-4': 'Wall Panel Walnut',
    'wall-panel-revestimiento-acustico-alistonado-roble-3-caras': 'Wall Panel Roble 3 Caras',
    'wall-panel-revestimiento-alistonado-roble': 'Wall Panel Roble Curvable',
    'wall-panel-revestimiento-acustico-alistonado-laqueado-negro': 'Wall Panel Laqueado Negro',
    'puerta-proma-modelo-7000-lisa-laqueado-blanco': 'Proma 7000 Lisa',
    'puerta-proma-modelo-212-replanada-laqueado-blanco': 'Proma 212 Replanada'
  };
  const clean = (value, limit = 180) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);

  function quoteContext() {
    try {
      const draft = JSON.parse(localStorage.getItem('mrparquet:project-quote:v1') || 'null');
      if (draft?.version !== 1 || !Array.isArray(draft.items) || !(Date.parse(draft.expiresAt) > Date.now())) return null;
      const format = (value) => value.toLocaleString('es-UY', { maximumFractionDigits: 2 });
      const lines = [];
      const labels = [];
      // Only catalog references and quantities belong in this message, never contact/project fields.
      for (const item of draft.items) {
        if (!item || typeof item.productTitle !== 'string' || typeof item.url !== 'string') continue;
        const path = item.url.match(/^\/products\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:[?#]|$)/);
        const variant = typeof item.variantId === 'string' && /^[1-9]\d{0,19}$/.test(item.variantId) ? item.variantId : '';
        const title = clean(item.productTitle);
        if (!path || !variant || !title) continue;
        const amount = Number(item.inputMode === 'sqm' ? item.areaSqm : item.requestedUnits);
        if (!Number.isFinite(amount) || amount < (item.inputMode === 'sqm' ? 0.01 : 1) || amount > 100000) continue;
        let quantity;
        if (item.inputMode === 'sqm') {
          const waste = Number(item.wastePercent);
          const coverage = Number(item.coverageM2PerPackage);
          if (!Number.isFinite(waste) || waste < 0 || waste > 100 || !Number.isFinite(coverage) || coverage < 0) continue;
          const effective = Math.round((amount * (1 + waste / 100) + Number.EPSILON) * 100) / 100;
          const packages = coverage > 0 ? Math.ceil(effective / coverage) : 0;
          quantity = `${format(amount)} m²${waste > 0 ? ` + ${format(waste)}% de margen` : ' · margen final a confirmar'} = ${format(effective)} m² estimados${packages ? ` · ${packages} caja${packages === 1 ? '' : 's'}` : ''}`;
        } else if (item.inputMode === 'unit') {
          const units = Math.ceil(amount);
          quantity = `${units} unidad${units === 1 ? '' : 'es'}`;
        } else continue;
        const variantName = typeof item.variantTitle === 'string' && item.variantTitle !== 'Default Title' ? clean(item.variantTitle) : '';
        const label = [title, variantName].filter(Boolean).join(' · ');
        const reference = `https://mrparquet.com.uy/products/${path[1]}?variant=${variant}`;
        labels.push(label);
        lines.push(`${label}\n${quantity}\nProducto: ${reference}`);
      }
      if (!lines.length) return null;
      return { message: `Materiales de mi borrador:\n\n${lines.join('\n\n')}\n\nCantidades estimadas; a confirmar con un asesor.`, label: labels.join(' · ') };
    } catch (_) { return null; }
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    const intent = clean(params.get('motivo'), 70);
    const productHandle = clean(params.get('producto'));
    const model = clean(params.get('modelo'));
    const productKey = productHandle || model;
    const suppliedTitle = clean(params.get('producto_nombre'));
    const knownProduct = Object.prototype.hasOwnProperty.call(knownProducts, productKey) ? knownProducts[productKey] : '';
    const productLabel = suppliedTitle || knownProduct || productKey.replace(/-/g, ' ');
    const suppliedMessage = clean(params.get('consulta'), 2000);
    const variantName = clean(params.get('variante_nombre'));
    const variantValue = params.get('variante') || '';
    const variantId = /^[1-9]\d{0,19}$/.test(variantValue) ? variantValue : '';
    const selectedIntent = Object.prototype.hasOwnProperty.call(intents, intent) ? intents[intent] : null;
    if (!selectedIntent && !productLabel && !suppliedMessage && !variantName && !variantId) return;
    const quote = intent === 'presupuesto' && params.get('origen') === 'cotizador' &&
      !productLabel && !suppliedMessage && !variantName && !variantId ? quoteContext() : null;

    const parts = [suppliedMessage || (selectedIntent ? selectedIntent[1] : productLabel
      ? `Me interesa ${productLabel}. Quisiera conversar sobre sus opciones, cantidades e instalación para mi proyecto.`
      : 'Quisiera recibir asesoramiento de Mr. Parquet.')];
    if (productLabel && (suppliedMessage || selectedIntent)) parts.push(`Material: ${productLabel}.`);
    if (model && model !== productKey && model !== productLabel) parts.push(`Modelo: ${model}.`);
    if (variantName) parts.push(`Variante: ${variantName}.`);

    // A query can supply a product handle, never a destination host or full URL.
    if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(productKey)) {
      const productUrl = new URL(`/products/${productKey}`, 'https://mrparquet.com.uy');
      // Use the native product route so doors, care and sports keep their commercial template.
      if (variantId) productUrl.searchParams.set('variant', variantId);
      parts.push(`Producto: ${productUrl.href}`);
    } else if (variantId) {
      parts.push(`ID de variante: ${variantId}.`);
    }
    if (quote) parts.push(quote.message);
    const message = parts.join('\n\n');

    document.querySelectorAll('[data-at-advisor-link]').forEach((link) => {
      let destination;
      try { destination = new URL(link.getAttribute('href')); } catch (_) { return; }
      if (destination.protocol !== 'https:' || destination.host !== 'wa.me' ||
          destination.username || destination.password || !/^\/\d+\/?$/.test(destination.pathname)) return;
      destination.searchParams.set('text', message);
      link.href = destination.href;
    });

    document.querySelectorAll('[data-at-contact]').forEach((root) => {
      const context = root.querySelector('[data-at-contact-context]');
      const label = root.querySelector('[data-at-contact-product-label]');
      if (!context || !label) return;
      if (!productLabel && !quote) { context.hidden = true; label.textContent = ''; return; }
      label.textContent = quote ? quote.label : [productLabel, variantName].filter(Boolean).join(' · ');
      context.hidden = false;
    });
  }

  init();
  // A Shopify section reload may replace either list. Reapplying the same text is safe.
  if (!document.documentElement.dataset.atContactLinksReady) {
    document.documentElement.dataset.atContactLinksReady = 'true';
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('project-quote:change', init);
  }
})();
